import React from "react";
import styled from "styled-components";
import { PageWrapper } from "Styles";
import logowhite from "assets/images/white-logo.png";
import TextFormInput from "components/TextFormInput";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
const Footer = () => {
  const formSchema = yup.object({
    email: yup.string().email("Invalid email format").required("Email is required"),
  });

  const { control, handleSubmit, reset } = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: {
      email: "",
    },
  });
  

  const onSubmit = async (data) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailRegex.test(data.email)) {
      toast.error("Please enter a valid email address.");

      return;
    }

    try {
      const response = await axios.post(
        "https://st-api.corpine.com/api/v1/corpine/subscribe",
        { email: data.email }
      );
      toast.success(response.data.message || "Subscription successful!");
      reset();
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to subscribe. Please try again.";
      toast.error(errorMessage);
    }
  };

  return (
    <FooterWrapper>
      <PageWrapper>
        <FooterContent>
          <img src={logowhite} alt="" />
          <FooterText>
           Keep up to date with our products and services, we promise not to spam you. We are also trying to reduce mailing costs too 😄
          </FooterText>
          <FooterForm onSubmit={handleSubmit(onSubmit)}>
                <TextFormInput
                    style={{ backgroundColor: "white", color: "black" }}
                    type="email"
                    inputWidth="50%"
                    label=""
                    name="email"
                    control={control}
                    className="form-control  form-group mb-2"
                />
            <button type="submit">Submit</button>
          </FooterForm>
        </FooterContent>
        {/* <hr /> */}
        <FooterContent>
          <FooterText>
            C/O Aacsl Accountants Ltd, 1st Floor, North Westgate House, Harlow,
            Essex, United Kingdom, CM20 1YS
          </FooterText>
          <Copyright>© {new Date().getFullYear()} Corpine Lab </Copyright>
        </FooterContent>
      </PageWrapper>
      <ToastContainer />
    </FooterWrapper>
  );
};

export default Footer;

const FooterWrapper = styled.div`
  width: 100%;
  background-color: #111111;
  padding-top: 40px;
  padding-bottom: 40px;

    hr {
  border: 1px solid #3A3A3A;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 30px;
  }
`;

const FooterContent = styled.div`
  width: 70%;
  margin: auto;
  text-align: center;
  @media(max-width: 768px){
  width: 75%}
    @media(max-width: 576px){
  width: 100%}
`;

const FooterText = styled.p`
  font-size: 14px;
  line-height: 1.4em;
`;

const FooterForm = styled.form`
  display: flex;
  gap: 8px;
  justify-content: center;

  button {
    height: 50px;
    border-color: transparent;
    outline: 0;
    color: white;
    font-weight: 500;
    width: 100px;
    background-color: #2b7fff;
    border-radius: 6px;
  }
    @media(max-width: 576px){
    div{
    width: 75% !important;
    }
    }
`;
const Copyright = styled.p`
  font-size: 12px;
  margin-top: 0px;
  color: #BBBBBB;
`;
